import { render, staticRenderFns } from "./DisclosureCardSmall.vue?vue&type=template&id=41a3008d"
import script from "./DisclosureCardSmall.vue?vue&type=script&lang=js"
export * from "./DisclosureCardSmall.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {AiSummaryButton: require('/vercel/path0/components/AiSummaryButton.vue').default,PopupAttachmentButton: require('/vercel/path0/components/blocks/PopupAttachmentButton.vue').default,AttachmentListDropdown: require('/vercel/path0/components/blocks/AttachmentListDropdown.vue').default,CustomDropdown: require('/vercel/path0/components/ui/CustomDropdown.vue').default})
